import './_filters.scss';
import { DateRangePicker } from 'vanillajs-datepicker';
import 'vanillajs-datepicker/css/datepicker.css';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { KeyboardEvent } from 'react';
import customSelects from 'custom-select';

export default function Filters() {
    const $filtersComponent = document.querySelectorAll('.filters');
    const data = document.querySelector('[data-filter]') as HTMLScriptElement;
    let dataOptions: any = [];

    if (data) {
        dataOptions = JSON.parse(data.innerHTML);

        let allItems: any = {};

        Object.keys(dataOptions).forEach(key => {
            dataOptions[key] = dataOptions[key].filter((item: any) => {
                const itemId = item.tid;
                if (!allItems[itemId]) {
                    allItems[itemId] = true;
                    return true;
                }
                return false;
            });
        });
    }

    if ($filtersComponent.length) {
        $filtersComponent.forEach(($filter, index) => {
            const $filterBtn = $filter.querySelector('.filter-title') as HTMLElement;
            const $filterWrapper = $filter.querySelector('.filters-wrapper') as HTMLElement;
            const $mask = $filter.querySelector('.mask') as HTMLElement;
            const $closeBtn = $filterWrapper.querySelector('.close-btn') as HTMLElement;
            const $search = $filter.querySelector('.search') as HTMLElement;
            const $inputSearch = $search.querySelector('input') as HTMLInputElement;
            const $wrapperFilters = $filterWrapper.querySelectorAll('.filter');
            const $noMediaFilter = $filter.querySelectorAll('.filter:not(.media)');
            const $applyBtn = $filter.querySelector('.apply-btn') as HTMLElement;
            const $clearBtn = $filter.querySelector('.clear-btn') as HTMLElement;
            const $filtersNumber = $filter.querySelector('.number') as HTMLElement;

            $filtersNumber.textContent += '0';

            // ─── Scroll preservation ──────────────────────────────────────────────────
            // Drupal Views AJAX, dopo ogni submit, scrolla automaticamente verso la view.
            // Salviamo la posizione corrente prima di ogni submit e la ripristiniamo
            // al termine della risposta AJAX tramite l'evento jQuery ajaxComplete di Drupal.
            let savedScrollY: number | null = null;

            function saveScroll() {
                savedScrollY = window.scrollY;
            }

            function restoreScroll() {
                if (savedScrollY !== null) {
                    // Usiamo requestAnimationFrame per assicurarci che il DOM AJAX
                    // sia già stato aggiornato prima di ripristinare la posizione.
                    requestAnimationFrame(() => {
                        window.scrollTo({ top: savedScrollY as number, behavior: 'instant' });
                        savedScrollY = null;
                    });
                }
            }

            // Drupal espone jQuery globalmente; ajaxComplete si aggancia al ciclo AJAX di Views.
            // Il controllo su (window as any).jQuery evita errori in ambienti non-Drupal.
            const jQ = (window as any).jQuery;
            if (jQ) {
                jQ(document).on('ajaxComplete', (_event: any, _xhr: any, settings: any) => {
                    // Filtriamo solo le chiamate AJAX di Views (contengono 'view_name' nei dati)
                    if (settings?.data && settings.data.indexOf('view_name') !== -1) {
                        restoreScroll();
                    }
                });
            }
            // ─────────────────────────────────────────────────────────────────────────

            init();

            function init() {
                initCarousel();
                create();
                ui();
                search();
                resetFilters();
                syncUIFromUrl();
            }

            function syncUIFromUrl() {
                const params = new URLSearchParams(window.location.search);

                $filter.querySelectorAll('.filter:not(.project-objectives) .wrapper-input input[type="checkbox"]').forEach((input: any) => {
                    const paramName = input.getAttribute('name');
                    const value = input.getAttribute('value');
                    const paramValues = params.getAll(paramName);
                    input.checked = paramValues.includes(value);
                });

                countFilters();
            }

            function initCarousel() {
                const $carousel = $filter.querySelectorAll('.views-element-container');

                $carousel.forEach((item: any) => {
                    let maxHeight = 0;
                    const $wrapper = item.querySelector('.cactus_view_rows') as HTMLElement;
                    const maxTotalSlides = ($filter.querySelector('.content-wrapper') as HTMLElement).getAttribute('data-carousel-items-number');

                    if ($wrapper) {
                        item.classList.add('swiper');
                        $wrapper.classList.add('swiper-wrapper');

                        const swiperBtnNext = $filter.querySelector('.swiper-button-next') as HTMLElement;
                        const swiperBtnPrev = $filter.querySelector('.swiper-button-prev') as HTMLElement;
                        const pagination = $filter.querySelector('.swiper-pagination') as HTMLElement;
                        const slides = Array.from($wrapper.querySelectorAll('.swiper-slide'));

                        if (slides.length > Number(maxTotalSlides)) {
                            const cardsToShow = slides.splice(0, Number(maxTotalSlides));
                            cardsToShow.forEach(card => {
                                card.classList.add('to-show');
                            });

                            slides.forEach(card => {
                                if (!card.classList.contains('to-show')) {
                                    card.remove();
                                }
                            });
                        }

                        const loopedSlides =
                            item.querySelector('.video-card') || item.querySelector('.image-card')
                                ? slides.length > 4
                                : item.querySelector('.tender-notice-card')
                                  ? slides.length > 3
                                  : slides.length > 2;

                        if (swiperBtnPrev && swiperBtnNext && pagination) {
                            swiperBtnNext.classList.add(`next-${index}`);
                            swiperBtnPrev.classList.add(`prev-${index}`);
                            pagination.classList.add(`pagination-${index}`);
                        }

                        const swiper = new Swiper(item, {
                            modules: [Navigation, Pagination],
                            loop: loopedSlides,
                            pagination: {
                                el: `.pagination-${index}`,
                                clickable: true,
                            },
                            navigation: {
                                nextEl: `.next-${index}`,
                                prevEl: `.prev-${index}`,
                                addIcons: false,
                            },
                            breakpoints: {
                                0: {
                                    slidesPerGroup: 1,
                                    slidesPerView: 1.155,
                                    spaceBetween: 12,
                                },
                                768: {
                                    spaceBetween: 28,
                                    slidesPerGroup: item.querySelector('.video-card') || item.querySelector('.image-card') ? 2 : item.querySelector('.tender-notice-card') ? 3 : 2,
                                    slidesPerView: item.querySelector('.video-card') || item.querySelector('.image-card') ? 2 : item.querySelector('.tender-notice-card') ? 3 : 2,
                                },
                                991: {
                                    spaceBetween: 28,
                                    slidesPerGroup: item.querySelector('.video-card') || item.querySelector('.image-card') ? 4 : item.querySelector('.tender-notice-card') ? 3 : 2,
                                    slidesPerView: item.querySelector('.video-card') || item.querySelector('.image-card') ? 4 : item.querySelector('.tender-notice-card') ? 3 : 2,
                                },
                            },
                            on: {
                                afterInit: function () {
                                    const bullets = pagination.querySelectorAll('.swiper-pagination-bullet');
                                    bullets.forEach((bullet: any) => {
                                        bullet.setAttribute('tabindex', '0');
                                        bullet.addEventListener('keydown', (event: any) => {
                                            if (event.key === 'ArrowLeft') {
                                                event.preventDefault();
                                                swiper.slidePrev();
                                            } else if (event.key === 'ArrowRight') {
                                                event.preventDefault();
                                                swiper.slideNext();
                                            }
                                        });
                                    });
                                },
                                // al caricamento della pagina, il focus viene impostato sul primo bullet e questo causa un effetto di scroll della pagina, quindi ho commentato questa parte di codice
                                // slideChange: function () {
                                //     if (pagination) {
                                //         const currentSlide = pagination.querySelector('.swiper-pagination-bullet.swiper-pagination-bullet-active') as HTMLDivElement;
                                //         if (currentSlide) {
                                //             currentSlide.focus({ preventScroll: false });
                                //         }
                                //     }
                                // },
                            },
                        });

                        // FIX 3: rimosso swiper.init() ridondante — Swiper si inizializza già nel costruttore
                        // e una doppia init può causare un secondo ciclo di rendering con effetti collaterali.

                        if (swiperBtnPrev.classList.contains('swiper-button-disabled') && swiperBtnNext.classList.contains('swiper-button-disabled')) {
                            const $buttons = $filter.querySelector('.buttons') as HTMLElement;
                            $buttons.classList.add('d-none');
                        }

                        if (swiperBtnNext) {
                            swiperBtnNext.addEventListener('keypress', function (e) {
                                if (e.code === 'Enter') {
                                    swiper.slideNext();
                                }
                            });
                        }

                        if (swiperBtnPrev) {
                            swiperBtnPrev.addEventListener('keypress', function (e) {
                                if (e.code === 'Enter') {
                                    swiper.slidePrev();
                                }
                            });
                        }

                        swiper.update();

                        const $newsCards = $wrapper.querySelectorAll('.news-card');
                        const $newsCardsImage = $wrapper.querySelectorAll('.news-card-image');

                        if ($newsCards) {
                            $newsCards.forEach((card: any) => {
                                const cardHeight = card.offsetHeight;
                                if (cardHeight > maxHeight) {
                                    maxHeight = cardHeight;
                                }
                            });
                            $newsCards.forEach((card: any) => {
                                card.style.height = `${maxHeight}px`;
                            });
                        }

                        if ($newsCardsImage) {
                            $newsCardsImage.forEach((card: any) => {
                                const cardHeight = card.offsetHeight;
                                if (cardHeight > maxHeight) {
                                    maxHeight = cardHeight;
                                }
                            });
                            $newsCardsImage.forEach((card: any) => {
                                card.style.height = `${maxHeight}px`;
                            });
                        }

                        openImageModal(item);
                        openVideoModal(item);
                        handleVideoNoCover(item);
                        handleVideoWithCover(item);
                    }
                });
            }

            function openImageModal(item: any) {
                const $imageCards = item.querySelectorAll('.image-card');

                if ($imageCards.length) {
                    const $modal = $filter.querySelector('.modal-img') as HTMLElement;
                    const $modalImg = $modal.querySelector('img') as HTMLImageElement;
                    const $modalTitle = $modal.querySelector('.title') as HTMLDivElement;

                    $imageCards.forEach(($card: any) => {
                        const $maskMedia = $filter.querySelector('.mask.media') as HTMLElement;
                        const $close = $maskMedia.querySelector('.btn-close') as HTMLElement;

                        $card.addEventListener('click', () => {
                            $modal.classList.remove('d-none');
                            $card.classList.add('full-screen');
                            const $cardFull = item.querySelector('.image-card.full-screen') as HTMLElement;
                            const cardSrc = ($cardFull.querySelector('img') as HTMLElement).getAttribute('src') as any;
                            $modalImg.setAttribute('src', cardSrc);
                            $maskMedia.classList.remove('d-none');
                            document.body.style.overflow = 'hidden';
                            $modalTitle.innerText = ($cardFull.querySelector('.title') as HTMLDivElement).innerText;
                        });

                        $card.addEventListener('keypress', (e: KeyboardEvent) => {
                            if (e.code === 'Enter') {
                                $modal.classList.remove('d-none');
                                $card.classList.add('full-screen');
                                const $cardFull = item.querySelector('.image-card.full-screen') as HTMLElement;
                                const cardSrc = ($cardFull.querySelector('img') as HTMLElement).getAttribute('src') as any;
                                $modalImg.setAttribute('src', cardSrc);
                                $maskMedia.classList.remove('d-none');
                                document.body.style.overflow = 'hidden';
                                $modalTitle.innerText = ($cardFull.querySelector('.title') as HTMLDivElement).innerText;
                            }
                        });

                        $maskMedia.addEventListener('click', () => {
                            $modal.classList.add('d-none');
                            $maskMedia.classList.add('d-none');
                            document.body.style.overflow = 'scroll';
                            $card.classList.remove('full-screen');
                        });

                        $close.addEventListener('click', () => {
                            $modal.classList.add('d-none');
                            $maskMedia.classList.add('d-none');
                            document.body.style.overflow = 'scroll';
                            $card.classList.remove('full-screen');
                        });

                        $close.addEventListener('keypress', e => {
                            if (e.code === 'Enter') {
                                $modal.classList.add('d-none');
                                $maskMedia.classList.add('d-none');
                                document.body.style.overflow = 'scroll';
                                $card.classList.remove('full-screen');
                            }
                        });
                    });
                }
            }

            function handleVideoNoCover(item: any) {
                const $videoNoCover = item.querySelectorAll('.video-card.no-cover:not(.rest-media .video-card.youtube-video.no-cover)');
                if ($videoNoCover.length) {
                    $videoNoCover.forEach(($el: any) => {
                        const $ytVideo = $el.querySelector('.yt-video') as HTMLIFrameElement;
                        const $videoCover = $el.querySelector('.video-yt-cover') as HTMLElement;
                        const $infoWrapper = $ytVideo?.parentElement?.querySelector('.info-wrapper') as HTMLElement;
                        const $titleWrapper = $ytVideo?.parentElement?.querySelector('.title-wrapper') as HTMLElement;

                        window.addEventListener('load', () => {
                            $el.addEventListener('click', () => {
                                $infoWrapper.classList.add('d-none');
                                $titleWrapper.classList.add('d-none');
                                $ytVideo.setAttribute('src', $ytVideo.src + '&autoplay=1');
                                $videoCover && $videoCover.classList.add('d-none');
                            });
                        });
                    });
                }
            }

            function handleVideoWithCover(item: any) {
                const $videoWithCover = item.querySelectorAll('.video-card.youtube-video:not(.rest-media .video-card.youtube-video.no-cover)');
                $videoWithCover.forEach(($el: any) => {
                    const $playBtn = $el.querySelector('.play-btn') as HTMLDivElement;
                    const $ytVideo = $el.querySelector('.yt-video') as HTMLIFrameElement;
                    const $videoCover = $el.querySelector('.video-yt-cover') as HTMLElement;
                    const $infoWrapper = $ytVideo?.parentElement?.querySelector('.info-wrapper') as HTMLElement;
                    const $titleWrapper = $ytVideo?.parentElement?.querySelector('.title-wrapper') as HTMLElement;

                    window.addEventListener('load', () => {
                        $el.addEventListener('click', () => {
                            $videoCover && $videoCover.classList.add('d-none');
                            $playBtn && $playBtn.classList.add('d-none');
                            $infoWrapper.classList.add('d-none');
                            $titleWrapper.classList.add('d-none');
                            $ytVideo.setAttribute('src', $ytVideo.src + '&autoplay=1');
                        });
                    });
                });
            }

            function openVideoModal(item: any) {
                const $videoCards = item.querySelectorAll('.video-card:not(.rest-media .video-card)');
                if ($videoCards.length) {
                    $videoCards.forEach(($el: any) => {
                        const $maskMedia = $filter.querySelector('.mask.media') as HTMLElement;
                        const $close = $maskMedia.querySelector('.btn-close') as HTMLElement;
                        const $video = $el.querySelector('video') as HTMLVideoElement;
                        const $playBtn = $el.querySelector('.play-btn') as HTMLElement;
                        const $ytVideo = $el.querySelector('.yt-video') as HTMLIFrameElement;
                        const $modal = $filter.querySelector('.modal-video') as HTMLElement;
                        const $modalVideo = $modal.querySelector('video') as HTMLVideoElement;
                        const $modalTitle = $modal.querySelector('.title') as HTMLDivElement;

                        if ($ytVideo) {
                            $el.classList.add('youtube-video');
                            $ytVideo.setAttribute('src', $ytVideo.src + '?enablejsapi=1');
                            const $videoCover = $el.querySelector('.video-yt-cover') as HTMLElement;
                            const $imageCover = $videoCover.querySelector('.image-cover') as HTMLElement;

                            if (!$imageCover) {
                                $el.classList.add('no-cover');
                            }
                        }

                        if ($video) {
                            $modalVideo.controls = false;
                            $playBtn.addEventListener('click', () => {
                                $video.parentElement?.classList.add('full-screen');
                                $modal.classList.remove('d-none');
                                const $videoFull = item.querySelector('.video-card.full-screen') as HTMLElement;
                                const videoSrc = ($videoFull.querySelector('video') as HTMLElement).getAttribute('src') as any;
                                $modalVideo.setAttribute('src', videoSrc);
                                $modalVideo.play();
                                $playBtn.classList.add('d-none');
                                $modalVideo.controls = true;
                                $maskMedia.classList.remove('d-none');
                                document.body.style.overflow = 'hidden';
                                $modalTitle.innerText = ($videoFull.querySelector('.title') as HTMLDivElement).innerText;
                            });

                            $modalVideo.addEventListener('ended', () => {
                                $playBtn.classList.remove('d-none');
                                $modal.classList.add('d-none');
                                $maskMedia.classList.add('d-none');
                                document.body.style.overflow = 'scroll';
                                $video.parentElement?.classList.remove('full-screen');
                                $modalVideo.controls = false;
                                $modalVideo.load();
                                $video.controls = false;
                            });

                            $playBtn.addEventListener('keypress', function (e) {
                                if (e.code === 'Enter') {
                                    $video.parentElement?.classList.add('full-screen');
                                    $modal.classList.remove('d-none');
                                    const $videoFull = item.querySelector('.video-card.full-screen') as HTMLElement;
                                    const videoSrc = ($videoFull.querySelector('video') as HTMLElement).getAttribute('src') as any;
                                    $modalVideo.setAttribute('src', videoSrc);
                                    $modalVideo.play();
                                    $playBtn.classList.add('d-none');
                                    $modalVideo.controls = true;
                                    $maskMedia.classList.remove('d-none');
                                    document.body.style.overflow = 'hidden';
                                    $modalTitle.innerText = ($videoFull.querySelector('.title') as HTMLDivElement).innerText;
                                }
                            });

                            $maskMedia.addEventListener('click', () => {
                                $playBtn.classList.remove('d-none');
                                $modal.classList.add('d-none');
                                $maskMedia.classList.add('d-none');
                                document.body.style.overflow = 'scroll';
                                $video.parentElement?.classList.remove('full-screen');
                                $modalVideo.controls = false;
                                $modalVideo.load();
                                $video.controls = false;
                            });

                            $close.addEventListener('click', () => {
                                $playBtn.classList.remove('d-none');
                                $modal.classList.add('d-none');
                                $maskMedia.classList.add('d-none');
                                document.body.style.overflow = 'scroll';
                                $video.parentElement?.classList.remove('full-screen');
                                $modalVideo.controls = false;
                                $modalVideo.load();
                                $video.controls = false;
                            });

                            $close.addEventListener('keypress', e => {
                                if (e.code === 'Enter') {
                                    $playBtn.classList.remove('d-none');
                                    $modal.classList.add('d-none');
                                    $maskMedia.classList.add('d-none');
                                    document.body.style.overflow = 'scroll';
                                    $video.parentElement?.classList.remove('full-screen');
                                    $modalVideo.controls = false;
                                    $modalVideo.load();
                                    $video.controls = false;
                                }
                            });
                        }
                    });
                }
            }

            function search() {
                const $searchBtn = $search.querySelector('.button') as HTMLElement;

                $searchBtn.addEventListener('click', () => {
                    setSearchValue();
                });

                $inputSearch.addEventListener('keypress', e => {
                    if (e.key === 'Enter') {
                        setSearchValue();
                    }
                });

                $searchBtn.addEventListener('keypress', e => {
                    if (e.key === 'Enter') {
                        setSearchValue();
                    }
                });
            }

            function ui() {
                $wrapperFilters.forEach($item => {
                    const $label = $item.querySelector('.input-wrapper .label') as HTMLElement;
                    const $labelSelect = $item.querySelector('label') as HTMLLabelElement;
                    const $inputs = $item.querySelectorAll('input[type="checkbox"]');

                    if ($label) {
                        $label.addEventListener('click', () => {
                            $item.classList.toggle('visible');
                        });

                        $label.addEventListener('keypress', e => {
                            if (e.code === 'Enter') {
                                $item.classList.toggle('visible');
                            }
                        });
                    }

                    if ($labelSelect) {
                        $labelSelect.addEventListener('click', () => {
                            $item.classList.toggle('visible');
                        });

                        $labelSelect.addEventListener('keypress', e => {
                            if (e.code === 'Enter') {
                                $item.classList.toggle('visible');
                            }
                        });
                    }

                    if ($inputs) {
                        $inputs.forEach(($input: any) => {
                            $input.addEventListener('keypress', (e: KeyboardEvent) => {
                                if (e.code === 'Enter') {
                                    $input.checked = !$input.checked;
                                }
                            });
                        });
                    }
                });

                if (window.innerWidth < 768) {
                    const $filtersProject = $filter.querySelector('.filter.project-objectives') as HTMLElement;
                    if ($filtersProject) {
                        const selectCustom = customSelects($filtersProject.querySelector('select'));
                        const $selectWrapper = $filtersProject.querySelector('.select-wrapper') as HTMLElement;

                        const selectCustomCont = selectCustom[0].select.customSelect as any;
                        const selectCustomContainer = selectCustomCont.container;
                        const selectPanel = selectCustomContainer.querySelector('.custom-select-opener');
                        selectPanel.setAttribute('tabindex', '-1');

                        $selectWrapper.addEventListener('keypress', e => {
                            if (e.code === 'Enter') {
                                selectCustomContainer.classList.toggle('is-open');
                            }
                        });
                    }
                }

                open();
                close();
                initDateRangePicker();
                applyFilters();
                clearFilters();
                initProjectFilters();
            }

            function initDateRangePicker() {
                const $dateFilter = $filter.querySelectorAll('.date');
                const dateRangeOptions: any = {
                    format: 'dd/mm/yyyy',
                    locale: 'it-IT',
                };

                let dateRangePicker;
                $dateFilter.length &&
                    $dateFilter.forEach(($date: any) => {
                        dateRangePicker = new DateRangePicker($date, dateRangeOptions);
                        dateRangePicker.element?.addEventListener('changeDate', () => {
                            $applyBtn.classList.remove('disabled');

                            countFilters();
                        });
                    });

                $applyBtn.addEventListener('click', () => {
                    setDateRangeValues();
                });

                $applyBtn.addEventListener('keypress', e => {
                    if (e.code === 'Enter') {
                        setDateRangeValues();
                    }
                });
            }

            function create() {
                if (dataOptions) {
                    Object.keys(dataOptions).forEach(key => {
                        if (dataOptions[key].length === 0) {
                            const $inputWrapper = $filter.querySelector(`.input-wrapper[name="${key}"]`) as HTMLDivElement;
                            $inputWrapper && $inputWrapper?.parentElement?.classList.add('d-none');
                        } else {
                            $noMediaFilter.forEach($el => {
                                const $inputWrapper = $el.querySelector(`.input-wrapper[name="${key}"]`);
                                if ($inputWrapper) {
                                    dataOptions[key].forEach((item: any, index: number) => {
                                        const wrapper = document.createElement('div');
                                        wrapper.classList.add('wrapper-input');
                                        wrapper.setAttribute('tabindex', '0');
                                        const label = document.createElement('label');
                                        label.setAttribute('for', `${item.filter_ref}${index}`);
                                        label.textContent = item.name;
                                        const checkbox = document.createElement('input');
                                        checkbox.setAttribute('type', 'checkbox');
                                        checkbox.setAttribute('value', item.tid);
                                        checkbox.setAttribute('name', item.filter_ref);
                                        checkbox.setAttribute('id', `${item.filter_ref}${index}`);
                                        if (item.filter_ref) {
                                            checkbox.setAttribute('data-field-mapping', item.filter_ref);
                                        }
                                        if (item.field_int_min && item.field_int_max) {
                                            checkbox.setAttribute('data-field-max', item.field_int_max);
                                            checkbox.setAttribute('data-field-min', item.field_int_min);
                                        }

                                        wrapper.appendChild(checkbox);
                                        wrapper.appendChild(label);
                                        $inputWrapper.appendChild(wrapper);
                                    });
                                }
                            });
                        }

                        const $selectWrapper = $filter.querySelector(`.select-wrapper select[name="${key}"]`);
                        if ($selectWrapper) {
                            dataOptions[key].forEach((item: any) => {
                                const option = document.createElement('option');
                                option.value = item.tid;
                                option.textContent = item.name;
                                option.setAttribute('data-field-mapping', item.filter_ref);

                                $selectWrapper.appendChild(option);
                            });
                        }
                    });
                }
            }

            function clearFilters() {
                $clearBtn.addEventListener('click', () => {
                    clearValues();
                });

                $clearBtn.addEventListener('keypress', e => {
                    if (e.code === 'Enter') {
                        clearValues();
                    }
                });
            }

            function syncCheckedToDrupal() {
                // Reset tutti i select Drupal tranne specific_objectives e items_per_page
                $filter
                    .querySelectorAll('select[data-drupal-selector]:not([data-drupal-selector="edit-specific-objectives"]):not([data-drupal-selector="edit-items-per-page"]) option')
                    .forEach((option: any) => {
                        option.selected = false;
                    });

                // Reset fieldset finanziari
                $filter.querySelectorAll('fieldset[data-drupal-selector="edit-financial-endowment-wrapper"] input').forEach((input: any) => {
                    input.value = '';
                });

                // Sincronizza i checkbox spuntati nei select Drupal
                $filter.querySelectorAll('.filter:not(.project-objectives) .wrapper-input input:checked').forEach((input: any) => {
                    const mapping = input.getAttribute('data-field-mapping') || input.getAttribute('name');
                    const value = input.getAttribute('value');
                    const drupalSelect = $filter.querySelector(`select[name="${mapping}"]`) as HTMLSelectElement;
                    if (drupalSelect) {
                        const option = drupalSelect.querySelector(`option[value="${value}"]`) as HTMLOptionElement;
                        if (option) option.selected = true;
                    }

                    // Gestione endowment range
                    const fieldMin = input.getAttribute('data-field-min');
                    const fieldMax = input.getAttribute('data-field-max');
                    if (fieldMin && fieldMax) {
                        const endowmentsInput = $filter.querySelector('fieldset[data-drupal-selector="edit-financial-endowment-wrapper"]') as HTMLElement;
                        if (endowmentsInput) {
                            const drupalInputMin = endowmentsInput.querySelector('input[name="financial_endowment[min]"]') as HTMLInputElement;
                            const drupalInputMax = endowmentsInput.querySelector('input[name="financial_endowment[max]"]') as HTMLInputElement;
                            if (drupalInputMin) drupalInputMin.value = fieldMin;
                            if (drupalInputMax) drupalInputMax.value = fieldMax;
                        }
                    }
                });
            }

            function initProjectFilters() {
                const $filterProjectObjectives = $filter.querySelector('.filter.project-objectives') as HTMLElement;

                if ($filterProjectObjectives) {
                    if (window.innerWidth > 768) {
                        const $wrappersInput = $filterProjectObjectives.querySelectorAll('.wrapper-input');
                        const $inputsProject = $filterProjectObjectives.querySelectorAll('input');

                        $inputsProject.forEach(($input, index) => {
                            if (index === 0) {
                                $input.parentElement?.classList.add('active');
                                $input.classList.add('active');
                                $input.checked = true;

                                // FIX 1: skipSubmit=true — evita il drupalSubmitBtn.click() all'init,
                                // che causa un re-render AJAX di Drupal Views con scroll indesiderato.
                                setProjectListFilters(true);
                            }

                            $input.addEventListener('click', () => {
                                $inputsProject.forEach($item => {
                                    $item.parentElement?.classList.remove('active');
                                    $item.classList.remove('active');
                                    $item.checked = false;
                                });

                                $input.parentElement?.classList.add('active');
                                $input.classList.add('active');
                                $input.checked = true;

                                // FIX 2: rimosso $applyBtn.click() — era un doppio submit.
                                // setProjectListFilters() chiama già drupalSubmitBtn.click() internamente,
                                // rendendo $applyBtn.click() ridondante e causante una race condition AJAX.
                                setProjectListFilters();
                            });
                        });

                        $wrappersInput.forEach($wrapper => {
                            const $input = $wrapper.querySelector('input') as HTMLInputElement;
                            $wrapper.addEventListener('keypress', e => {
                                // @ts-ignore
                                if (e.code === 'Enter') {
                                    $wrappersInput.forEach($item => {
                                        const $input = $item.querySelector('input') as HTMLInputElement;
                                        $item.classList.remove('active');
                                        $input.classList.remove('active');
                                        $input.checked = false;
                                    });

                                    $input.checked = true;
                                    $input.classList.add('active');
                                    $wrapper.classList.add('active');

                                    // FIX 2 (keypress): stesso fix del click — rimosso $applyBtn.click() doppio.
                                    setProjectListFilters();
                                }
                            });
                        });
                    } else {
                        const optionProject = $filterProjectObjectives.querySelectorAll('.custom-select-option');
                        optionProject.forEach((option, index) => {
                            option.setAttribute('tabindex', '0');
                            if (index === 0) {
                                option.classList.add('active');

                                const drupalSelect = $filter.querySelector('select[data-drupal-selector="edit-specific-objectives"]') as HTMLSelectElement;
                                const drupalOptions = Array.from(drupalSelect.querySelectorAll('option'));
                                drupalOptions.forEach((el: any) => {
                                    const value = el.getAttribute('value');
                                    if (option.getAttribute('data-value') === value) {
                                        el.selected = true;
                                        el.setAttribute('checked', 'true');
                                    }
                                });

                                // FIX 1 (mobile): rimosso drupalSubmitBtn.click() all'init.
                                // La selezione dell'opzione 0 è già rispecchiata nel DOM Drupal;
                                // il submit avverrà al primo click utente, non al caricamento pagina.
                            }

                            option.addEventListener('click', () => {
                                optionProject.forEach($item => {
                                    $item.classList.remove('active');
                                });
                                option.classList.add('active');

                                const drupalSelect = $filter.querySelector('select[data-drupal-selector="edit-specific-objectives"]') as HTMLSelectElement;
                                const drupalOptions = Array.from(drupalSelect.querySelectorAll('option'));
                                drupalOptions.forEach((el: any) => {
                                    const value = el.getAttribute('value');
                                    if (option.getAttribute('data-value') === value) {
                                        el.selected = true;
                                        el.setAttribute('checked', 'true');
                                    }
                                });

                                const drupalSubmitBtn = $filter.querySelector('form .js-form-submit') as HTMLFormElement;
                                if (drupalSubmitBtn) {
                                    saveScroll();
                                    drupalSubmitBtn.click();
                                }
                            });
                        });
                    }
                }
            }

            function applyFilters() {
                $applyBtn.addEventListener('click', () => {
                    setFiltersValues();
                });

                $applyBtn.addEventListener('keypress', e => {
                    if (e.code === 'Enter') {
                        setFiltersValues();
                    }
                });
            }

            function setFiltersValues() {
                syncCheckedToDrupal();

                $filterWrapper.classList.remove('visible');
                $mask.classList.add('d-none');
                document.body.style.overflow = 'scroll';

                const drupalSubmitBtn = $filter.querySelector('form .js-form-submit') as HTMLFormElement;
                if (drupalSubmitBtn) {
                    saveScroll();
                    drupalSubmitBtn.click();
                }
            }

            function setSearchValue() {
                const $submit = $filter.querySelector('.view-filters form [type="submit"]') as HTMLInputElement;
                const $drupalInput = $filter.querySelector('.view-filters form input[data-drupal-selector="edit-search"]') as HTMLInputElement;
                if ($drupalInput) {
                    $drupalInput.value = $inputSearch.value;
                }

                // FIX scroll: anche la ricerca testuale passa per il submit Drupal AJAX,
                // quindi salviamo la posizione prima del click come per gli altri filtri.
                if ($submit) {
                    saveScroll();
                    $submit.click();
                }
            }

            function setDateRangeValues() {
                const $dateFilters = Array.from($filterWrapper.querySelectorAll('.filter.date'));
                let hasDate = false;

                $dateFilters.forEach(($input: any) => {
                    const selectedInputs = Array.from($input.querySelectorAll('input')) as HTMLInputElement[];
                    if (!selectedInputs[0] || selectedInputs[0].value === '') return;

                    const fieldMapping = $input.getAttribute('name');
                    const minDate = `${selectedInputs[0].value.split('/').reverse().join('-')} 00:00:00`;
                    const maxDate = `${selectedInputs[1].value.split('/').reverse().join('-')} 23:59:59`;

                    const drupalFieldset = $filter.querySelector(`fieldset[data-drupal-selector="${fieldMapping}"]`);
                    if (drupalFieldset) {
                        const drupalInputs = drupalFieldset.querySelectorAll('input');
                        if (drupalInputs[0]) drupalInputs[0].value = minDate;
                        if (drupalInputs[1]) drupalInputs[1].value = maxDate;
                        hasDate = true;
                    }
                });

                if (hasDate) {
                    const drupalSubmitBtn = $filter.querySelector('form .js-form-submit') as HTMLFormElement;
                    if (drupalSubmitBtn) {
                        saveScroll();
                        drupalSubmitBtn.click();
                    }
                }
            }

            // FIX 1 + FIX 2: aggiunto parametro skipSubmit (default false).
            // - skipSubmit=true: usato solo all'init per sincronizzare il DOM Drupal
            //   senza triggerare un submit AJAX che causerebbe scroll indesiderato.
            // - skipSubmit=false (default): comportamento normale al click utente.
            function setProjectListFilters(skipSubmit = false) {
                const drupalSelect = $filter.querySelector('select[data-drupal-selector="edit-specific-objectives"]') as HTMLSelectElement;
                const activeInput = $filter.querySelector('.filter.project-objectives input:checked') as HTMLInputElement;

                if (drupalSelect && activeInput) {
                    Array.from(drupalSelect.querySelectorAll('option')).forEach((option: any) => {
                        option.selected = option.getAttribute('value') === activeInput.value;
                        if (option.selected) {
                            option.setAttribute('checked', 'true');
                        } else {
                            option.removeAttribute('checked');
                        }
                    });
                }

                if (!skipSubmit) {
                    const drupalSubmitBtn = $filter.querySelector('form .js-form-submit') as HTMLFormElement;
                    if (drupalSubmitBtn) {
                        saveScroll();
                        drupalSubmitBtn.click();
                    }
                }
            }

            function clearValues() {
                $filterWrapper.classList.remove('visible');
                $mask.classList.add('d-none');
                document.body.style.overflow = 'scroll';

                // Salviamo la posizione corrente in sessionStorage prima del redirect.
                // window.location.href causa un reload completo della pagina, quindi
                // l'unico modo per sopravvivere alla navigazione è persistere il valore
                // fuori dal JS in-memory. sessionStorage è ideale: non sopravvive alla
                // chiusura del tab e non inquina localStorage con dati di navigazione.
                sessionStorage.setItem('filters_restore_scroll', String(window.scrollY));

                // Naviga all'URL base mantenendo solo specific_objectives (filtro obbligatorio)
                const activeObjective = $filter.querySelector('.filter.project-objectives input:checked') as HTMLInputElement;
                const params = activeObjective ? `?specific_objectives[]=${activeObjective.value}` : '';

                window.location.href = window.location.pathname + params;
            }

            // Ripristino scroll dopo "Rimuovi filtri".
            // Viene eseguito una volta sola al caricamento: se il valore è presente
            // in sessionStorage significa che siamo appena tornati da un clearValues(),
            // quindi scrolliamo alla posizione salvata e puliamo subito la chiave.
            const scrollAfterClear = sessionStorage.getItem('filters_restore_scroll');
            if (scrollAfterClear !== null) {
                sessionStorage.removeItem('filters_restore_scroll');
                // requestAnimationFrame assicura che il DOM sia già stato dipinto
                // prima di applicare la posizione, evitando un rimbalzo visibile.
                requestAnimationFrame(() => {
                    window.scrollTo({ top: Number(scrollAfterClear), behavior: 'instant' });
                });
            }

            const $inputs = Array.from($filter.querySelectorAll('.filter:not(.project-objectives) input[type="checkbox"]'));

            $inputs.forEach(input => {
                input.addEventListener('change', () => {
                    countFilters();
                });
            });

            function countFilters() {
                const $selectedFilters = $filter.querySelector('.selected-filters') as HTMLElement;
                const number = $selectedFilters.querySelector('.number') as HTMLDivElement;
                const $checkedInputs = $filter.querySelectorAll('.filter:not(.project-objectives) .input-wrapper input:checked');
                const $checkedInputsDates = document.querySelectorAll('.filter.date .date-range input[type="text"]');
                let $selectedInputDatesWrappers: any;
                let selectedInputDatesWrappersArray: any = [];

                if ($checkedInputsDates.length) {
                    $selectedInputDatesWrappers = Array.from($checkedInputsDates).map((input: any) => {
                        if (input.value != '') {
                            return input.closest('.date-range');
                        }
                    });

                    $selectedInputDatesWrappers.forEach((el: any) => {
                        if (!selectedInputDatesWrappersArray.includes(el) && el !== undefined) {
                            selectedInputDatesWrappersArray.push(el);
                        }
                    });
                }

                const $selectedInputWrappers = Array.from($checkedInputs).map(input => {
                    return input.closest('.input-wrapper');
                });

                let selectedInputWrappersArray: any = [];
                $selectedInputWrappers.forEach(el => {
                    if (!selectedInputWrappersArray.includes(el)) {
                        selectedInputWrappersArray.push(el);
                    }
                });

                if (number) {
                    number.innerHTML = selectedInputWrappersArray.length + selectedInputDatesWrappersArray.length;
                }
            }

            function open() {
                if (window.innerWidth < 768) {
                    const $header = document.querySelector('.header') as HTMLElement;
                    let headerHeight: any;
                    headerHeight = $header.clientHeight;

                    $filterBtn.addEventListener('click', () => {
                        $filterWrapper.classList.add('visible');
                        $mask.classList.add('d-none');
                    });

                    if ($filterWrapper) {
                        $filterWrapper.style.top = `${headerHeight}px`;

                        window.addEventListener('scroll', () => {
                            if (window.scrollY > headerHeight) {
                                $filterWrapper.style.top = '0px';
                            } else {
                                $filterWrapper.style.top = `${headerHeight}px`;
                            }
                        });
                    }
                } else {
                    $filterBtn.addEventListener('click', () => {
                        $filterWrapper.classList.add('visible');
                        $mask.classList.remove('d-none');
                        document.body.style.overflow = 'hidden';
                    });

                    $filterBtn.addEventListener('keypress', e => {
                        if (e.code === 'Enter') {
                            $filterWrapper.classList.add('visible');
                            $mask.classList.remove('d-none');
                            document.body.style.overflow = 'hidden';
                        }
                    });
                }
            }

            function close() {
                $closeBtn.addEventListener('click', () => {
                    $filterWrapper.classList.remove('visible');
                    $mask.classList.add('d-none');
                    document.body.style.overflow = 'scroll';
                });

                $closeBtn.addEventListener('keypress', e => {
                    if (e.code === 'Enter') {
                        $filterWrapper.classList.remove('visible');
                        $mask.classList.add('d-none');
                        document.body.style.overflow = 'scroll';
                    }
                });

                $mask.addEventListener('click', () => {
                    $filterWrapper.classList.remove('visible');
                    $mask.classList.add('d-none');
                    document.body.style.overflow = 'scroll';
                });
            }

            function resetFilters() {
                const drupalOptions = $filter.querySelectorAll('.form-select:not([data-drupal-selector="edit-specific-objectives"]):not([data-drupal-selector="edit-items-per-page"]) option');
                drupalOptions.forEach((option: any) => {
                    option.selected = false;
                    option.removeAttribute('checked');
                });
            }
        });
    }
}
